import { useContext } from "react";
// @ts-ignore
import Mustache from "mustache";
import { OrganizationProvider } from "@/features/websites/components/OrganizationProvider";
import { WebsiteContext } from "@/pages/website/WebsiteProvider";
import { useEditor } from "@craftjs/core";
import { SectionContext } from "../blocks/section-block/SectionBlock";
import { useParams } from "react-router-dom";
import { formatPhoneIntl } from "@/utils/phones";

const global = {
  year: new Date().getFullYear(),
};

const useVariableValues = (forceParsing?: boolean) => {
  const { query } = useEditor();
  const organization = useContext(OrganizationProvider);
  const websiteContext = useContext(WebsiteContext);
  const section = useContext(SectionContext);
  const { organizationAlias } = useParams<{ organizationAlias?: string }>();

  const getValue = (value: string | number) => {
    const isEditorEnabled = query.getOptions().enabled;
    if (!value || !organization || (!forceParsing && isEditorEnabled) || !["string", "number"].includes(typeof value)) return value;

    try {
      const context = {
        ...global,
        ...organization,
        ...(section || {}),
        ...websiteContext.organization,
        website: websiteContext.website,
        stablishment: websiteContext.stablishment,
        product: websiteContext.product,
        catalog: websiteContext.catalog,
        organizationAlias,
        formatPhone: () => (text: string, render: (template: string) => string) => {
          const rawValue = render(text).trim();
          return formatPhoneIntl(rawValue);
        },
      };
      const output = Mustache.render(value.toString(), context);
      return output;
    } catch (error) {
      console.error(error);
    }

    return;
  };

  return {
    getValue,
  };
};

export default useVariableValues;

